var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Page',{staticClass:"pagination",attrs:{"total":_vm.dataCount,"show-sizer":"","page-size-opts":[10,20,50,100],"page-size":_vm.pageSize},on:{"on-page-size-change":_vm.sizeChange,"on-change":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }